import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import take from "./take.js";
import go1 from "./go1.js";
export default function head(iter) {
  return go1(take(1, iter), function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        h = _ref2[0];

    return h;
  });
}